import React from 'react'

const CgiBd = ({
  bipolar = {
    latest: 'Mildly ill',
    previous: 'Moderately ill',
    entry: 'Markedly ill',
  },
  anxiety = {
    latest: ' Mildly ill',
    previous: 'Moderately ill',

    entry: 'Moderately ill',
  },
}) => {
  const columns = [
    { key: 'latest', label: 'Now' },
    { key: 'previous', label: 'Previous' },
    { key: 'entry', label: 'At Enrollment' },
  ]

  const rows = [
    { label: 'Overall bipolar illness', values: bipolar },
    { label: 'Anxiety', values: anxiety },
  ]

  const severityScale = [
    { score: 1, label: 'No symptoms' },
    { score: 2, label: 'Very mild symptoms' },
    { score: 3, label: 'Mild symptoms' },
    { score: 4, label: 'Moderate symptoms' },
    { score: 5, label: 'Significant symptoms' },
    { score: 6, label: 'Severe symptoms' },
    { score: 7, label: 'Very severe symptoms' },
  ]

  return (
    <section style={styles.container}>
      <div className="title6">Here's how your clinician rates how you're doing:</div>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th scope="col" style={{ ...styles.cell, ...styles.labelCell }} />
              {columns.map(column => (
                <th key={column.key} scope="col" style={styles.cell}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map(row => (
              <tr key={row.label}>
                <th scope="row" style={{ ...styles.cell, ...styles.labelCell }}>
                  {row.label}
                </th>
                {columns.map(column => (
                  <td key={column.key} style={{
                    ...styles.cell,
                    ...(column.key === 'latest' ? styles.nowCell : {}),
                  }}>
                    {row.values?.[column.key] || 'Not assessed'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/*<div>
        {severityScale.map(item => (
          <span key={item.score} style={styles.scaleItem}>
            {item.score}: {item.label} |&nbsp;
          </span>
        ))}
      </div>*/}
    </section>
  )
}

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    color: '#222',
    width: '100%',
  },
  title: {
    fontSize: 22,
    margin: '0 0 8px',
  },
  description: {
    fontSize: 15,
    lineHeight: 1.5,
    margin: '0 0 16px',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    minWidth: 600,
  },
  cell: {
    border: '1px solid #d8d8d8',
    padding: '12px 16px',
    textAlign: 'center',
  },
  labelCell: {
    fontWeight: 500,
    textAlign: 'left',
  },
    nowCell: {
    fontWeight: 600,
  },
}

export default CgiBd
